import type { ComponentType } from 'react';
import type { PublicForm } from '../types';
import { PandaDocEmbed } from './PandaDocEmbed';

/**
 * Provider registry: adding a new form provider later (Typeform, Google
 * Forms, native …) means registering a new component here — nothing else
 * on the public site changes.
 */
const REGISTRY: Record<PublicForm['provider'], ComponentType<{ form: PublicForm }>> = {
  pandadoc: PandaDocEmbed,
};

export function ProviderEmbed({ form }: { form: PublicForm }) {
  const Impl = REGISTRY[form.provider] ?? PandaDocEmbed;
  return <Impl form={form} />;
}
